// @flow
import zentakeApi from 'api'
import OpacityBg from 'components/OpacityBg'
import * as React from 'react'
import type { Message } from 'types/message'
import Ui from 'ui'
import TextField from 'ui/molecules/TextField'

import { ButtonGroup } from '@/ui/atoms/ButtonGroup'

import DELIVERY_METHODS from '../data/deliveryMethods'
type Props = {
  isVisible: boolean,
  clientName: string,
  email: string,
  phone: string,
  onClose: () => void,
  preferredDeliveryMethod: string,
  message: Message,
}

function ModalSendReminder({
  isVisible,
  clientName,
  email,
  phone,
  onClose,
  preferredDeliveryMethod,
  message,
}: Props): React.Node {
  const [toggleDeliveryMethod, setToggleDeliveryMethod] = React.useState<
    'sms' | 'email',
  >(preferredDeliveryMethod)

  const willUseEmail = toggleDeliveryMethod === 'email'

  const [loading, setLoading] = React.useState(false)

  const onSubmit = React.useCallback(
    async (newEmailOrPhone, deliveryType) => {
      setLoading(true)
      try {
        await zentakeApi.sendMessageReminder(
          message?.id,
          newEmailOrPhone,
          deliveryType
        )

        // Update user email
        message?.customer?.id &&
          (await zentakeApi.updateClient(
            message?.customer.id,
            deliveryType === DELIVERY_METHODS.SMS
              ? {
                  phone_number: newEmailOrPhone,
                }
              : {
                  email: newEmailOrPhone,
                }
          ))
      } catch (error) {
      } finally {
        setLoading(false)
        onClose()
      }
    },
    [message?.customer.id, message?.id, onClose]
  )

  async function onPressButton() {
    if (toggleDeliveryMethod === 'email') {
      onSubmit(email, DELIVERY_METHODS.EMAIL)
    } else {
      onSubmit(phone, DELIVERY_METHODS.SMS)
    }
  }

  return (
    isVisible && (
      <OpacityBg onClick={onClose || (() => {})}>
        <div
          className="relative mx-3 max-w-sm flex-1 space-y-4 rounded bg-white px-4 py-4"
          onClick={(e) => e.stopPropagation()}
        >
          <h4 className="text-lg font-medium text-txt-emphasis">
            Send Reminder
          </h4>
          <div>
            <TextField
              disabled
              grayOutWhenDisabled
              label="Client Name"
              name="clientName"
              placeholder="No name on file"
              type="text"
              value={clientName}
            />
          </div>
          <div className="flex flex-row pb-1">
            <ButtonGroup.Root>
              <ButtonGroup.Item
                isActive={!willUseEmail}
                onClick={() => setToggleDeliveryMethod('sms')}
              >
                SMS
              </ButtonGroup.Item>
              <ButtonGroup.Item
                isActive={willUseEmail}
                onClick={() => setToggleDeliveryMethod('email')}
              >
                Email
              </ButtonGroup.Item>
            </ButtonGroup.Root>
          </div>
          <div className="mt-1">
            {!willUseEmail ? (
              <Ui.SingleLinePhone
                disabled
                grayOutWhenDisabled
                name="input"
                placeholder="No phone on file"
                type="text"
                value={phone}
              />
            ) : (
              <TextField
                disabled
                grayOutWhenDisabled
                name="input"
                placeholder="No email on file"
                type="text"
                value={email}
              />
            )}
          </div>
          <div className="flex flex-row justify-between justify-items-center">
            <div className="flex flex-col">
              <Ui.ButtonClear className="border" onClick={onClose}>
                Cancel
              </Ui.ButtonClear>
            </div>
            <div className="flex flex-col">
              <Ui.PrimaryButton
                disabled={(willUseEmail && !email) || (!willUseEmail && !phone)}
                loading={loading}
                onClick={onPressButton}
              >
                Send
              </Ui.PrimaryButton>
            </div>
          </div>
        </div>
      </OpacityBg>
    )
  )
}

export default ModalSendReminder
